/**
 * FormCategoriesService
 * CRUD for admin-managed form categories.
 * Route: forms/api/forms/categories
 */
import { CrudService } from '../base/CrudService';
/** Service for FormCategory CRUD operations */
export class FormCategoriesService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? FormCategoriesService.DEFAULT_SERVICE_PATH,
            basePath: FormCategoriesService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
FormCategoriesService.DEFAULT_SERVICE_PATH = 'forms';
FormCategoriesService.BASE_PATH = 'api/forms/categories';
//# sourceMappingURL=FormCategoriesService.js.map